import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import ModalHeaderComponent from './modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import ModalPortal from '../../../components/modal-portal';
import SaveButton from './save-button';

import { FILTERSET_EDITOR_TYPE_ALLOCATION_RULE, FILTERSET_EDITOR_TYPE_ORDER_FILTER } from '../constants/filterset-editor-type';
import EditorForm from '../components/editor-form';
import messages from './messages';
import style from './style.module.less';

const NewFilterEditorModal = ({ onClose, filtersetEditorType }) => {
  return (
    <ModalPortal containerId='new-filter-modal' onClose={onClose}>
      <Modal>
        <ModalHeaderComponent closeModal={onClose} filtersetEditorType={filtersetEditorType} />
        <ModalBody className={style['modal-body']}>
          <EditorForm filtersetEditorType={filtersetEditorType} />
        </ModalBody>
        <ModalFooter className={style['modal-footer']}>
          <Button onClick={onClose} theme='tertiary'>
            <FormattedMessage {...messages.filterEditorCancel} />
          </Button>
          <SaveButton closeModalHandler={onClose} />
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

NewFilterEditorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  filtersetEditorType: PropTypes.oneOf([FILTERSET_EDITOR_TYPE_ALLOCATION_RULE, FILTERSET_EDITOR_TYPE_ORDER_FILTER]),
};

export default NewFilterEditorModal;
